import TimeDependenceOfWork from "./containers/TimeDependenceOfWork";
export default TimeDependenceOfWork;